import rg4js from 'raygun4js'

export default {
  methods: {
    logError (error) {
      rg4js('send', error)
    }
  }
}
